import { EditorThread, EditorThreadComment } from './editor-thread.types'
import { formatRelativeTime } from './utils/format-relative-time'

export type CommentHeaderMeta = {
  authorName: string | null
  createdAtRelative: string | null
}

export function getFirstComment(thread: EditorThread | null): EditorThreadComment | null {
  return thread?.comments[0] ?? null
}

export function getThreadReplies(thread: EditorThread | null): EditorThreadComment[] {
  return thread?.comments.slice(1) ?? []
}

export function toCommentHeaderMeta(thread: EditorThread | null): CommentHeaderMeta {
  const first = getFirstComment(thread)
  if (first === null) {
    return { authorName: null, createdAtRelative: null }
  }
  return { authorName: first.userName, createdAtRelative: formatRelativeTime(first.createdAt) }
}
